package game.entity

import game.Game
import game.Room

class TrunkMazeBattle : Entity() {
    var step = 0
    val lumberjack = Entity()
    val trunk = Entity()

    val pong = PongBattle(
        PongBattleConfig(
            "trunk-paddle",
            "imp-paddle",
            "cactus",
            false,
            0.15,
            19,
            1.5,
            19.5,
        )
    ) {
        step++
    }

    override fun onInit(game: Game, room: Room) {
        lumberjack.apply {
            col = 1
            row = 9
            sprite = game.getSpriteById("imp-paddle")
        }

        trunk.apply {
            col = 48
            row = 9
            sprite = game.getSpriteById("trunk-paddle")
        }

        room.entities.add(lumberjack)
        room.entities.add(trunk)
    }

    override fun onTick(game: Game, room: Room) {
        when (step) {
            0 -> {
                if (game.player.col == 49) {
                    room.addEntity(pong)
                    room.removeEntity(lumberjack)
                    room.removeEntity(trunk)
                    step++
                }
            }
            1-> {
                // wait for done
            }
            2-> {
                room.removeEntity(pong)
                room.removePermanently(game, this)
            }
        }
    }
}